import { render, staticRenderFns } from "./statistical-analysis-external-views-labeled-sample.vue?vue&type=template&id=1d64f565&scoped=true&"
import script from "./statistical-analysis-external-views-labeled-sample.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-external-views-labeled-sample.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-external-views-labeled-sample.scss?vue&type=style&index=0&id=1d64f565&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64f565",
  null
  
)

export default component.exports